import { createFileRoute } from '@tanstack/react-router';
import CollectionDataPage from '@/pages/workspaces/journeys/collections/[collectionId]/data.page';
import { LazyPage } from './-route-layouts';

function CollectionDataRoute() {
  return (
    <LazyPage>
      <CollectionDataPage />
    </LazyPage>
  );
}

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/journeys/collections/$collectionId/data')(
  {
    component: CollectionDataRoute,
  },
);
